import script from "./image.vue?vue&type=script&setup=true&lang=js"
export * from "./image.vue?vue&type=script&setup=true&lang=js"

import "./image.vue?vue&type=style&index=0&id=68a6c51d&lang=css"

const __exports__ = script;

export default __exports__